module.exports = __webpack_public_path__ + "img/hbst.f2fded60.png";